import { type TReduxState } from '@/microfrontends/filters/shared/store';

import { type TTrackingUser } from './types';

export function getTrackingUser(state: TReduxState): TTrackingUser {
  if (state.user.data.isAuthenticated) {
    return {
      userId: state.user.data.userId,
    };
  }

  return {};
}
